import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const structureApiSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'structureApi'

export const config = {
	site: structureApiSiteConfig,
	reactRendererSite: structureApiSiteConfig,
	reactNativeSite: structureApiSiteConfig,
	name,
}
